
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) visible: boolean
  @Prop({ type: Boolean, default: false }) showGoLearn: boolean
  @Prop({ required: true }) productId: string
  @Prop({ required: false }) qrcodeUrl: string

  isCheck: boolean = false

  get StatisticsData() {
    return this.$store.$courseV2.StatisticsData
  }

  async fetchData() {
    // 我的页面-课程加群二维码不需要请求获取
    if (!this.showGoLearn) {
      await this.$store.$courseV2.StatisticsData.getAssistantUrl(this.productId)
    }
  }

  onReset() {
    this.isCheck = false
  }

  @Watch('productId', { immediate: true })
  onShowAssistantUrl(val) {
    if (!val) return

    this.fetchData()
  }

  @Emit('change-check')
  changeCheck() {
    this.isCheck = !this.isCheck
  }

  @Emit('go-learn')
  goLearn() {
    this.$emit('close')
    return this.isCheck
  }

  @Emit('close')
  closeJoinClass() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    console.warn('销毁加群弹窗～')
    this.onReset()
  }
}
